import React, { FC } from 'react';

import { styled } from '@mui/material';

import GridViewIcon from '~/assets/icons/GridViewIcon';
import ListViewIcon from '~/assets/icons/ListViewIcon';
import { useDiscoverContext } from '~/context/DiscoverContext';
import { SearchResultsProps } from '~/pages/DiscoverPage/components/SearchResults/SearchResults';
import { DISCOVER_PAGE_EVENTS, GRID_VIEW, LIST_VIEW } from '~/pages/DiscoverPage/const';
import sendAnalyticEvent from '~/utils/sendAnalyticEvent';

interface ViewSwitcherProps {
  setPage: SearchResultsProps['setPage'];
}

const ViewSwitcher: FC<ViewSwitcherProps> = ({ setPage }) => {
  const { discoverView, setDiscoverView, setSearchState } = useDiscoverContext();

  const toggleView = (view: typeof LIST_VIEW | typeof GRID_VIEW) => {
    setPage?.(0);
    //set page to first to prevent breaking page logic
    setSearchState((prevState) => ({
      ...prevState,
      page: 1,
    }));
    setDiscoverView(view);
  };

  return (
    <Wrapper>
      <ListIcon
        data-testid="listIcon"
        isActive={discoverView === LIST_VIEW}
        onClick={() => {
          sendAnalyticEvent(DISCOVER_PAGE_EVENTS.listView);
          toggleView(LIST_VIEW);
        }}
      />
      <GridIcon
        data-testid="gridIcon"
        isActive={discoverView === GRID_VIEW}
        onClick={() => {
          sendAnalyticEvent(DISCOVER_PAGE_EVENTS.gridView);
          toggleView(GRID_VIEW);
        }}
      />
    </Wrapper>
  );
};

export default ViewSwitcher;

const Wrapper = styled('div')`
  display: none;
  background: ${({ theme }) => theme.palette.common.card.background.lightInverted};
  padding: 21px 16px;
  border-radius: 50px;

  ${({ theme }) => theme.breakpoints.up('md')} {
    display: flex;
  }
`;
const ListIcon = styled(ListViewIcon, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>`
  display: block;
  width: 17px;
  height: 13px;
  cursor: pointer;
  color: ${({ theme, isActive }) =>
    isActive ? theme.palette.common.icon.active : theme.palette.common.icon.gray};
  transition: 0.3s color;

  &:hover {
    color: ${({ theme, isActive }) => !isActive && theme.palette.common.icon.toggleViewHover};
  }
`;
const GridIcon = styled(GridViewIcon, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>`
  display: block;
  width: 17px;
  height: 14px;
  margin-left: 21px;
  cursor: pointer;
  color: ${({ theme, isActive }) =>
    isActive ? theme.palette.common.icon.active : theme.palette.common.icon.gray};
  transition: 0.3s color;

  &:hover {
    color: ${({ theme, isActive }) => !isActive && theme.palette.common.icon.toggleViewHover};
  }
`;
